import { render, staticRenderFns } from "./mismatch.vue?vue&type=template&id=690f927c&scoped=true&"
import script from "./mismatch.vue?vue&type=script&lang=js&"
export * from "./mismatch.vue?vue&type=script&lang=js&"
import style0 from "./mismatch.vue?vue&type=style&index=0&id=690f927c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f927c",
  null
  
)

export default component.exports